import angular from "angular";
import contentArticleComponent from './article.component';

export default angular.module('app.content.article', [
    'app.core'
]).component('contentArticle', contentArticleComponent);
